import { gql } from '@apollo/client';
import { PAYMENT_PROVIDER_PAYMENT_TYPE_FRAGMENT } from '@graphql/fragments/paymentProviderPaymentType';

export const GET_ORGANIZATION_PAYMENT_TYPES_QUERY = gql`
  query GetOrganizationPaymentTypes($organizationId: ID!, $paymentContext: OrganizationPaymentTypeContext) {
    organizationPaymentTypes(organizationId: $organizationId, paymentContext: $paymentContext) {
      id
      Enabled
      PaymentContext
      PaymentProviderPaymentType {
        ...PaymentProviderPaymentTypeFields
      }
    }
  }
  ${PAYMENT_PROVIDER_PAYMENT_TYPE_FRAGMENT}
`;
